// tabs/cleanliness/cleanliness.validate.ts
import type { CleanlinessModuleResult } from "./cleanliness.contract";

/**
 * VALIDATOR - ISOLATION NIVEAU 2
 * Fail-fast si les données sont corrompues ou manquantes.
 */
export function validateCleanliness(result: CleanlinessModuleResult): CleanlinessModuleResult {
  if (result.status !== "OK") return result;
  if (!result.data) {
    return { ...result, status: "INVALID", reason: "Données Cleanliness absentes alors que status=OK" };
  }

  const { ghostNotes, duration, ghostsPerMinute, thresholdErrPerMin } = result.data;

  if (!(duration > 0)) {
    return { ...result, status: "INVALID", reason: "Durée de session invalide (<= 0s)" };
  }

  if (!Array.isArray(ghostNotes)) {
    return { ...result, status: "INVALID", reason: "Tableau de bruits parasites corrompu" };
  }

  if (!Number.isFinite(ghostsPerMinute)) {
    return { ...result, status: "INVALID", reason: "ghostsPerMinute non numérique" };
  }

  if (!Number.isFinite(thresholdErrPerMin) || thresholdErrPerMin <= 0) {
    return { ...result, status: "INVALID", reason: "thresholdErrPerMin invalide" };
  }

  if (!Number.isFinite(result.score)) {
    return { ...result, status: "INVALID", reason: "Calcul du score a produit un NaN/Inf" };
  }

  return result;
}

